import {DropdownItem} from '@viptech/react-components'
import {useRef, useState} from 'react'
import api from 'src/services/api'

function useClients() {
  const [clients, setClients] = useState<DropdownItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const blockRequests = useRef(false)

  async function getClients(companyId?: number) {
    if (blockRequests.current) return
    blockRequests.current = true
    setIsLoading(true)
    try {
      const res = await api.client.getMany({filter: {companyIds: companyId ? [companyId] : undefined}})
      setClients(
        res.data.data.entities.map((it) => {
          return {id: `${it.id}`, label: it.name}
        }),
      )
    } catch (err) {
    } finally {
      blockRequests.current = false
      setIsLoading(false)
    }
  }

  return {clients, isLoading, getClients}
}

export default useClients
